import React, { useEffect, useRef, useState } from 'react';  
import { ToastContainer, toast } from 'react-toastify';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdCreate, MdBlock, MdAdd ,MdOutlineCircle} from "react-icons/md";
import ReactPaginate from 'react-paginate';
import img from '../../../assets/small-logo-512x512.png'
import img1 from '../../../assets/coin.png'
import profile from '../../../assets/small-logo-512x512.png'
import { Tooltip } from 'react-tooltip';
import _constantUtil from '../../../utils/Constant'; 
import Loader from '../../partial/Loader';
import { useNavigate } from 'react-router-dom';

function AllCategory() {
    const storedTheme = sessionStorage.getItem('themeMode'); 
    const [confirmation, setConfirmation] = useState(_constantUtil.BOOLEAN_FALSE);
    const [updateConfirmation, setUpdateConfirmation] = useState(_constantUtil.BOOLEAN_FALSE);
    const [profileImage, setProfileImage] = useState(img); 
    const [showConfirmation, setShowConfirmation] = useState(_constantUtil.BOOLEAN_FALSE); 
    const confirmationRef = useRef(_constantUtil.NULL);

    useEffect(() => {
      const handleClickOutside = (event) => {
          if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
              setConfirmation(_constantUtil.BOOLEAN_FALSE);
              setUpdateConfirmation(_constantUtil.BOOLEAN_FALSE);
              setShowConfirmation(_constantUtil.BOOLEAN_FALSE);
          }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);
      };    
    }, []); 
    
    const handleImageChange = (event) => {
      const file = event.target.files[_constantUtil.ZERO];
      if (file) {
      const reader = new FileReader();
      reader.onload = () => {
          setProfileImage(reader.result);
      };
      reader.onerror = (error) => {
          console.error("Error reading file:", error);
      };
      reader.readAsDataURL(file);
      }
    };

  return (
    <>
    <ToastContainer autoClose={2000} position='top-center' pauseOnHover='false' />
     {showConfirmation && (
        <div>
          <div className='confirmation-overlay'></div>
          <div ref={confirmationRef} className='confirmation-dialog'>
            <p>Are you sure to update category status?</p>
            <div className='d-flex justify-content-end '>
              <button onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white p-2'>Cancel</button>
              <button  className='border-0 rounded px-3 bg-success text-white p-2'  > Confirm </button>
            </div>
          </div>
        </div>
      )}
      {confirmation && (
        <div>
          <div className='team-confirmation-overlay'></div>
          <div ref={confirmationRef} className={`${storedTheme === 'dark' ? 'match-dark-confirmation-dialog' :  'match-light-confirmation-dialog'}`}>
            <h4>Add Category</h4>
            <hr className='hr-color'/>
              <form>
                <div className=" text-center">
                <img
                  src={profileImage}
                  alt='Profile'
                  className='img-thumbnail img-fluid'
                  style={{
                    borderRadius: '50%',
                    cursor: 'pointer',
                    objectFit: 'cover',
                    minHeight: '110px',
                    height: '110px',
                    maxWidth: '110px',
                    width: '110px',
                    backgroundColor: 'transparent'
                  }}
                /> 
                <div className='button-wrapper pt-2 mt-2'>
                  <span className='label blr-bg-dull-sky rounded'><p className='mb-0 px-1'>Upload File</p></span>
                  <div className="d-flex justify-content-center">
                  <input
                      type='file'
                      accept="image/png, image/jpeg, image/jpg" 
                      onChange={handleImageChange} 
                      className=' upload-box form-control'
                      name='upload' 
                      id='upload-modal'
                      placeholder='Upload File'
                    />
                  </div>
                </div>
              </div> 
              <div className="row">
                <div className='col-12 col-md-6 mb-2'>
                  <label htmlFor='name' className='form-label fw-semibold'>
                      Name
                  </label>
                  <input
                    type='text'
                    className='form-control w-100' 
                    id='name'
                    name='name'
                    placeholder='Enter Category Name' 
                    autoComplete='off'
                  /> 
                </div>
                  <div className='col-12 col-md-6 mb-2'>
                  <label htmlFor='priority' className='form-label fw-semibold'>
                  Priority 
                  </label>
                  <input
                    type='text'
                    className='form-control' 
                    id='priority'
                    name='priority'
                    placeholder='Enter Priority' 
                    autoComplete='off'
                  />  
                </div>
              </div>

            <div className='d-flex justify-content-end mt-3'>
              <button onClick={()=>setConfirmation(false)} className='border-0 rounded px-3 bg-danger text-white me-2 p-2'>Cancel</button>
              <button type='button' className='border-0 rounded px-3 bg-success text-white p-2' >Save</button>
            </div>
              </form>
          </div>
        </div>   
      )}  
      {updateConfirmation && (
        <div>
          <div className='team-confirmation-overlay'></div>
          <div ref={confirmationRef} className={`${storedTheme === 'dark' ? 'match-dark-confirmation-dialog' :  'match-light-confirmation-dialog'}`}>
            <h4>Update Category</h4>
            <hr className='hr-color'/>
              <form>
                <div className=" text-center">
                <img
                  src={profileImage}
                  alt='Profile'
                  className='img-thumbnail img-fluid'
                  style={{
                    borderRadius: '50%',
                    cursor: 'pointer',
                    objectFit: 'cover',
                    minHeight: '110px',
                    height: '110px',
                    maxWidth: '110px',
                    width: '110px',
                    backgroundColor: 'transparent'
                  }}
                /> 
                <div className='button-wrapper pt-2 mt-2'>
                  <span className='label blr-bg-dull-sky rounded'><p className='mb-0 px-1'>Upload File</p></span>
                  <div className="d-flex justify-content-center">
                  <input
                      type='file'
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={handleImageChange} 
                      className=' upload-box form-control'
                      name='upload' 
                      id='upload-modal'
                      placeholder='Upload File'
                    />
                  </div>
                </div>
              </div> 
              <div className="row">
                <div className='col-12 col-md-6 mb-2'>
                  <label htmlFor='name' className='form-label fw-semibold'>
                      Name
                  </label>
                  <input
                    type='text'
                    className='form-control w-100' 
                    id='name'
                    name='name'
                    placeholder='Enter Category Name' 
                    autoComplete='off'
                  /> 
                </div>
                  <div className='col-12 col-md-6 mb-2'>
                  <label htmlFor='priority' className='form-label fw-semibold'>
                  Priority 
                  </label>
                  <input
                    type='text'
                    className='form-control'  
                    id='priority'
                    name='priority'
                    placeholder='Enter Priority' 
                    autoComplete='off'
                  />  
                </div>
              </div>

            <div className='d-flex justify-content-end mt-3'>
              <button onClick={()=>setUpdateConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white me-2 p-2'>Cancel</button>
              <button type='button' className='border-0 rounded px-3 bg-success text-white p-2' >Save</button>
            </div>
              </form>
          </div>
        </div>   
      )}  

        <div className='px-4 mt-4'>
          <div className='container-fluid p-0'>
              <div className='row'>
                  <h4 className='header-title pb-3 text-muted'>All Category</h4>
                  <div className='col-12'>
                      <div className='card'>
                          <div className='card-body'>

                              <div className='d-flex justify-content-end align-items-center mb-2'>
                                  <div className=''>
                                      <button
                                          type='button'
                                          onClick={() => setConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                          className='btn text-white d-flex align-items-center'>
                                          <MdAdd className='fs-5 me-1  ' />
                                          Add
                                      </button>
                                  </div>
                              </div>

                              <div className='table-responsive'>
                                  <table id='scroll-horizontal-datatable' className='table w-100 nowrap'>
                                      <thead>
                                          <tr>
                                              <th>SN</th>
                                              <th>Profile</th>
                                              <th>Category</th>
                                              <th>Priority</th>
                                              <th>Status</th>
                                              <th>Action</th>
                                          </tr>
                                      </thead>
                                      <tbody> 
                                          <tr >
                                              <td scope='row'>1</td>
                                            <td><img src={profile} alt="image"  className='user-img'/></td>
                                            <td>
                                              <span className='badge badge-info-lighten'>
                                                    1x2
                                              </span></td>
                                            <td>1</td>
                                            <td> 
                                                  <span className='badge badge-success-lighten'>
                                                    ACTIVE
                                                  </span> 
                                              </td>
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <MdCreate data-tooltip-id='questioncategory' data-tooltip-content="Update Category"  
                                                      className=' jumbo-icon  me-2 fs-5' style={{cursor: 'pointer', color:'gray'}}
                                                       onClick={() => setUpdateConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                        <Tooltip border={false} id='questioncategory' place="bottom" effect="solid" /> 
                                                  <>
                                                    <MdBlock data-tooltip-id='activebetscategory' data-tooltip-content="Inactive Category" 
                                                    className=' jumbo-icon me-2 text-danger pointer user-status fs-5' style={{ cursor: 'pointer'  }} 
                                                      onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                      />
                                                        <Tooltip border={false} id='activebetscategory' place="bottom" effect="solid" />
                                                  </> 
                                                  <>
                                                      <MdOutlineCircle
                                                      data-tooltip-id='inactivebetscategory' data-tooltip-content="Active Category"
                                                      className='jumbo-icon pointer text-success user-status fs-5 me-2' style={{cursor: 'pointer' }}   
                                                        onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                  />
                                                      <Tooltip id='inactivebetscategory' place="bottom" effect="solid"/>
                                                  </> 
                                                </div>
                                            </td>
                                        </tr> 
                                         
                                          <tr >
                                              <td scope='row'>2</td>
                                            <td><img src={img1} alt="image"  className='user-img'/></td>
                                            <td>
                                              <span className='badge badge-info-lighten'>
                                              Team Wins	
                                              </span></td>
                                            <td>2</td>
                                            <td>  
                                                  <span className='badge badge-success-lighten'>
                                                    ACTIVE
                                                  </span> 
                                              </td>
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <MdCreate data-tooltip-id='questioncategory' data-tooltip-content="Update Category"  
                                                      className=' jumbo-icon  me-2 fs-5' style={{cursor: 'pointer', color:'gray'}}
                                                       onClick={() => setUpdateConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                      />
                                                    <Tooltip border={false} id='questioncategory' place="bottom" effect="solid" />  
                                                  <>
                                                    <MdBlock data-tooltip-id='activebetscategory' data-tooltip-content="Inactive Category" 
                                                      className=' jumbo-icon me-2 text-danger pointer user-status fs-5' style={{ cursor: 'pointer'  }}  
                                                      onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                      />
                                                        <Tooltip border={false} id='activebetscategory' place="bottom" effect="solid" />
                                                  </> 
                                                  <>
                                                    <MdOutlineCircle
                                                      data-tooltip-id='inactivebetscategory' data-tooltip-content="Active Category"
                                                      className='jumbo-icon pointer text-success user-status fs-5 me-2' style={{cursor: 'pointer' }}   
                                                      onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                  />
                                                    <Tooltip id='inactivebetscategory' place="bottom" effect="solid"/>
                                                  </> 
                                                </div>
                                            </td>
                                        </tr> 
                                         
                                          <tr >
                                            <td scope='row'>3</td>
                                            <td><img src={img1} alt="image"  className='user-img'/></td>
                                            <td>
                                              <span className='badge badge-info-lighten'>
                                              Goal Score
                                              </span></td>
                                            <td>3</td>
                                            <td> 
                                                  <span className='badge badge-success-lighten'>
                                                    ACTIVE
                                                  </span>  
                                              </td>
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <MdCreate data-tooltip-id='questioncategory' data-tooltip-content="Update Category"  
                                                      className=' jumbo-icon  me-2 fs-5' style={{cursor: 'pointer', color:'gray'}}
                                                       onClick={() => setUpdateConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                      />
                                                    <Tooltip border={false} id='questioncategory' place="bottom" effect="solid" /> 
                                                  <>
                                                    <MdBlock data-tooltip-id='activebetscategory' data-tooltip-content="Inactive Category" 
                                                      className=' jumbo-icon me-2 text-danger pointer user-status fs-5' style={{ cursor: 'pointer'  }}   
                                                      onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                        />
                                                    <Tooltip border={false} id='activebetscategory' place="bottom" effect="solid" />
                                                  </> 
                                                  <>
                                                    <MdOutlineCircle
                                                      data-tooltip-id='inactivebetscategory' data-tooltip-content="Active Category"
                                                      className='jumbo-icon pointer text-success user-status fs-5 me-2' style={{cursor: 'pointer' }}     
                                                      onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                  />
                                                  <Tooltip id='inactivebetscategory' place="bottom" effect="solid"/>
                                                  </> 
                                                </div>
                                            </td>
                                        </tr> 



                                      </tbody>
                                  </table>
                              </div>
                              <ReactPaginate
                                  className='pagination' 
                                  previousLabel={<MdKeyboardArrowLeft className='fs-4'/>}
                                  nextLabel={<MdKeyboardArrowRight className='fs-4'/>}
                                  marginPagesDisplayed={2}
                                  pageRangeDisplayed={1}
                                  breakLabel={'..'}
                                  containerClassName={'pagination-container'}
                                  activeClassName={'pagination-active-page'}
                              /> 
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </>
  )
}

export default AllCategory
